export default __webpack_public_path__ + "static/media/dietDayImageActive.0b2b3730.svg";